<template>
  <div class="modal-body">
    <form @submit.prevent="handleSubmit">
      <!-- Success & Error Messages -->
      <div v-if="successMessage" class="alert alert-success">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <!-- Grade -->
      <div class="mb-3">
        <label class="form-label">Grade</label>
        <select class="form-select" v-model="newTopic.grade_id" required>
          <option value="" disabled>Select Grade</option>
          <option v-for="g in grades" :key="g.id" :value="g.id">
            {{ g.level }}
          </option>
        </select>
      </div>

      <!-- Subject -->
      <div class="mb-3">
        <label class="form-label">Subject</label>
        <select
          class="form-select"
          v-model="newTopic.subject_id"
          :disabled="!newTopic.grade_id"
          required
        >
          <option value="" disabled>Select Subject</option>
          <option v-for="s in subjects" :key="s.id" :value="s.id">
            {{ s.name }}
          </option>
        </select>
      </div>

      <!-- Topic Title -->
      <div class="mb-3">
        <label class="form-label">Topic Title</label>
        <input
          type="text"
          class="form-control"
          v-model="newTopic.title"
          placeholder="Enter topic title"
          required
        />
      </div>

      <!-- Description -->
      <div class="mb-3">
        <label class="form-label">Description</label>
        <textarea
          class="form-control"
          v-model="newTopic.description"
          rows="3"
          placeholder="Enter topic description"
        ></textarea>
      </div>

      <!-- Footer -->
      <div class="modal-footer p-0 mt-3">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button type="submit" class="btn btn-pink" :disabled="loading">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>
          {{ loading ? "Saving..." : "Save" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddTopic",

  data() {
    return {
      grades: [],
      subjects: [],
      loading: false,
      errorMessage: "",
      successMessage: "",
      newTopic: {
        grade_id: "",
        subject_id: "",
        title: "",
        description: "",
      },
    };
  },

  mounted() {
    this.fetchGrades();
  },

  watch: {
    "newTopic.grade_id"(newVal) {
      this.newTopic.subject_id = "";
      this.subjects = [];
      if (newVal) this.fetchSubjectsByGrade();
    },
  },

  methods: {
    async fetchGrades() {
      try {
        const res = await axios.get("/a-get-grades");
        this.grades = res.data;
      } catch (err) {
        console.error(err);
      }
    },

    async fetchSubjectsByGrade() {
      try {
        const res = await axios.get(
          `/a-grade-subjects?grade_id=${this.newTopic.grade_id}`,
        );
        this.subjects =
          res.data.subjects ||
          res.data.map((s) => ({ id: s.subject.id, name: s.subject.name }));
      } catch (err) {
        console.error(err);
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        this.errorMessage = "";
        this.successMessage = "";

        const res = await axios.post("/a-add-topic", this.newTopic);
        this.successMessage = "Topic added successfully!";

        // Emit the newly added topic to parent
        this.$emit("topic-added", res.data);

        // Reset form
        this.newTopic = {
          grade_id: "",
          subject_id: "",
          title: "",
          description: "",
        };
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || "Something went wrong.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-pink {
  background-color: #ff00cc;
  border: none;
  color: white;
}
.btn-pink:hover {
  background-color: #e600b3;
  color: white;
}
</style>
